module.exports = function() {
  return new Worker(__webpack_public_path__ + "7cfa31d736392b18913f.worker.js");
};